module.exports = __webpack_public_path__ + "img/examinationFm.ed2d8e27.png";